/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

//prevent cart link from navigating to cart page
document.querySelector(".utils__item.header-cart a")?.addEventListener("click", function(e) {
  e.preventDefault();
});


document.querySelectorAll('.js-accordion-trigger').forEach(item => {
  item.addEventListener('click', event => {
    $(".faq__category__title").css({ opacity: 1 });
  })
});
    
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

/* document.addEventListener('rebuy:cart.ready', (event) => { 
  var path = window.location.pathname;
  if(path.includes('/en-ca')) {
    console.log("It's Canada!");
    RebuyExperiments.run('smart-cart-9960');
    RebuyExperiments.run('156979');
  }

  document.querySelector('#cart-link').addEventListener('click', () => {
    Rebuy.SmartCart.show();
  });
}); */

document.addEventListener('DOMContentLoaded', function() {
  const SCROLL_OFFSET = 100;
  
  /**
   * readme for scrollToElement()
   * This function scrolls the user to the element identified by targetId, with some offset from the top.
   * Inputs:
   *   - targetId (string): ID or selector of the target element to scroll to.
   *   - retries (number): how many times to retry if the element is not found on the page.
   * Outputs:
   *   - No direct return value, but triggers page scroll behavior.
   * Features:
   *   - Smoothly scrolls to target element with offset
   *   - Retries if element not found initially
   *   - Auto-corrects final position if needed
   */
  function scrollToElement(targetId, retries = 5) {
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - SCROLL_OFFSET;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      // Re-check position and correct if off by more than 10px after 1 second
      setTimeout(() => {
        const finalElementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const currentScrollY = window.pageYOffset;
        const difference = Math.abs(finalElementPosition - (currentScrollY + SCROLL_OFFSET));

        // Optionally correct if there's still a large gap.
        if (difference > 10) {
          window.scrollTo({
            top: finalElementPosition - SCROLL_OFFSET,
            behavior: 'smooth'
          });
        }
      }, 1000);

    } else if (retries > 0) {
      setTimeout(() => {
        scrollToElement(targetId, retries - 1);
      }, 100);
    }
  }

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      scrollToElement(targetId);
    });
  });
});